<mat-card class="mat-card-user-detail">
  <mat-card-header>
    <mat-card-title>{{ 'label.user' | translate }}</mat-card-title>
    <mat-card-subtitle *ngIf="data?.isCreationMode">{{ 'label.creation' | translate }}</mat-card-subtitle>
    <mat-card-subtitle *ngIf="data?.isEditMode">{{ 'label.edition' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <mat-card-content>
      <div class="content-row" *ngIf="uiService.visibleByRole([Role.administrator])">
        <label class="content-row-label">{{ 'label.role' | translate }}</label>
        <app-role-list [control]="$any(userForm).controls['role']" class="content-row-input">
        </app-role-list>
      </div>

      <div class="content-row">
        <label class="content-row-label">{{ 'label.login' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="login" type="text" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.firstName' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="firstName" type="text" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.lastName' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="lastName" type="text" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.mail' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="email" type="text" autocomplete="off">
        </mat-form-field>
      </div>

      <div class="content-row" *ngIf="uiService.visibleByRole([Role.administrator])">
        <label class="content-row-label">{{ 'label.company' | translate }}</label>
        <app-company-list [control]="$any(userForm).controls['company']" class="content-row-input">
        </app-company-list>
      </div>




    </mat-card-content>
    <mat-card-actions class="report-error-card-action">
      <button mat-raised-button color="warn" type="button" (click)="onCancel()" style="margin: 0 8px;">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button"
        *ngIf="data?.user?.id == accountService.currentUser.value?.id" (click)="onChangePassword()">
        <mat-icon>lock</mat-icon> {{ 'button.change-password' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button"
        *ngIf="data?.user?.id != accountService.currentUser.value?.id && uiService.visibleByRole([Role.administrator])"
        (click)="onResetPassword()">
        <mat-icon>send</mat-icon> {{ 'button.reset-password' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="userForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>